import { createSlice } from '@reduxjs/toolkit';

import { getExternalInvitations } from './actions/get-external-invitations.action';
import { ExternalInvitation } from './entities/external-invitation.entity';

export type ExternalInvitationState = {
  items: ExternalInvitation[];
  isFetchingInvitations: boolean;
};

const initialState: ExternalInvitationState = {
  items: [],
  isFetchingInvitations: false,
};

export const externalInvitationSlice = createSlice({
  name: 'externalInvitation',
  initialState: initialState,
  reducers: {
    clearExternalInvitations(state) {
      state.items = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getExternalInvitations.pending, (state) => {
        state.isFetchingInvitations = true;
      })
      .addCase(getExternalInvitations.fulfilled, (state, action) => {
        state.isFetchingInvitations = false;
        state.items = action.payload;
      });
  },
});
